import React from "react";

import { Button, Input, Modal } from "../ui";

type CreateListModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  listName: string;
  onListNameChange: (value: string) => void;
  description: string;
  onDescriptionChange: (value: string) => void;
  title?: string;
  saveLabel?: string;
  isSubmitting?: boolean;
};

export default function CreateListModal({
  isOpen,
  onClose,
  onSave,
  listName,
  onListNameChange,
  description,
  onDescriptionChange,
  title = "Create List",
  saveLabel = "Save",
  isSubmitting = false,
}: CreateListModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      title={title}
      closeIconSrc="/icons/x_circle.svg"
      panelClassName="bg-white p-4"
      headerClassName="rounded-t-[12px] border border-border-grey border-b-0 bg-white px-4 pt-3"
      titleClassName="text-md !font-medium"
      bodyClassName="rounded-b-[12px] border border-t-0 border-border-grey bg-white px-4 py-4"
    >
      <div className="space-y-4">
        <Input
          label="New List Name*"
          size="sm"
          value={listName}
          onChange={(event) => onListNameChange(event.target.value)}
        />

        <div className="flex flex-col gap-[10px]">
          <label className="text-sm font-medium leading-normal text-dark-black">Description Optional</label>
          <textarea
            value={description}
            onChange={(event) => onDescriptionChange(event.target.value)}
            rows={5}
            placeholder="Description"
            className="h-[128px] w-full rounded-[4px] border border-light-grey bg-white px-[9px] pb-[5px] pt-[9px] text-md text-dark-black placeholder:text-dark-grey outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue"
          />
        </div>

        <Button
          variant="primary"
          size="sm"
          fullWidth
          isDisabled={!listName.trim() || isSubmitting}
          isLoading={isSubmitting}
          onClick={onSave}
        >
          {saveLabel}
        </Button>
      </div>
    </Modal>
  );
}
